export const TalaveraTile = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
    <rect x="2.5" y="2.5" width="59" height="59" rx="4" fill="#FDFBF7" stroke="#C5705D" strokeWidth="1.6" />
    <rect x="7" y="7" width="50" height="50" rx="2" fill="none" stroke="#C5705D" strokeWidth="0.8" opacity="0.55" />
    {[10.5, 53.5].map((x) =>
      [10.5, 53.5].map((y) => <circle key={`${x}-${y}`} cx={x} cy={y} r="1.6" fill="#C5705D" opacity="0.8" />)
    )}
    <g fill="#C5705D">
      {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
        <ellipse key={deg} cx="32" cy="16.5" rx="4.6" ry="10.5" transform={`rotate(${deg} 32 32)`} />
      ))}
    </g>
    <g fill="#C5705D" opacity="0.75">
      {[
        [49.55, 39.27], [39.27, 49.55], [24.73, 49.55], [14.45, 39.27],
        [14.45, 24.73], [24.73, 14.45], [39.27, 14.45], [49.55, 24.73],
      ].map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="1.7" />
      ))}
    </g>
    <circle cx="32" cy="32" r="6.2" fill="#F4C2A6" />
    <circle cx="32" cy="32" r="2.6" fill="#C5705D" />
  </svg>
);
